 import navigationReducer from './navigation';
 import sceneReducer from './scene';
 import stepReducer from './step';
 import tabReducer from './tab';
 import menuReducer from './menu';
 import minitourReducer from './minitour';
 import orientationReducer from './orientation';

export const navigation = navigationReducer;
export const scene = sceneReducer;
export const step = stepReducer;
export const tab = tabReducer;
export const menu = menuReducer;
export const minitour = minitourReducer;
export const orientation = orientationReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js